import API from '@/views/Fdc/Apis/'
import Dayjs from 'dayjs'
// import _ from 'lodash'

/**
 * TODO: 수정해야 할 항목 정리
 */
// FIXME: 1. 각 항목 테스트 필요

/**
 * Detection > Select Lot Modal component
 */
export default {
  name: 'LotsModal',
  watch: {
    /**
     * selectPeriodValue 변화 감지
     * Period option에 따라 option을 수정합니다.
     */
    selectPeriodValue () {
      let value = this.selectPeriodValue
      if (value === 'lastLot') {
        this.from = null
        this.to = null
        this.periodDisabled = true
        this.lastLotCntDisabled = false
      } else if (value === 'day') {
        this.from = Dayjs().subtract(1, 'days').toDate()
        this.to = new Date()
        this.periodDisabled = true
        this.lastLotCntDisabled = true
      } else if (value === 'week') {
        this.from = Dayjs().subtract(1, 'weeks').toDate()
        this.to = new Date()
        this.periodDisabled = true
        this.lastLotCntDisabled = true
      } else if (value === 'month') {
        this.from = Dayjs().subtract(1, 'months').toDate()
        this.to = new Date()
        this.periodDisabled = true
        this.lastLotCntDisabled = true
      } else if (value === 'custom') {
        this.periodDisabled = false
        this.lastLotCntDisabled = true
      }
    },
    /**
     * filterFault 변화감지
     */
    filterFault () {
      let value = this.filterFault
      if (value) this.filterFaultDisabled = false
      else this.filterFaultDisabled = true
    },
    /**
     * filterAlarm 변화감지
     */
    filterAlarm () {
      let value = this.filterAlarm
      if (value) this.filterAlarmDisabled = false
      else this.filterAlarmDisabled = true
    },
    /**
     * filterInterlock 변화감지
     */
    filterInterlock () {
      let value = this.filterInterlock
      if (value) this.filterInterlockDisabled = false
      else this.filterInterlockDisabled = true
    },
    /**
     * lotsModalVisible 변화 감지
     */
    lotsModalVisible () {
      this.modalVisible = this.lotsModalVisible
    }
  },
  mounted () {
  },
  beforeUpdate () {
  },
  beforeMount () {
    this.initColumns()
  },
  updated () {
    // TODO: 적용 필요 시 수정
    // if (this.$refs.lotsGrd) {
    //   if (this.$refs.lotsGrd.getCheckedRows()) {
    //     this.$watch(
    //       () => this.$refs.lotsGrd.getCheckedRows().length,
    //       (value) => {
    //         this.selectedRowCnt = value
    //       }
    //     )
    //   }
    // }
  },
  props: {
    lotsModalVisible: {
      type: Boolean,
      default: false
    },
    // FAB, EQP, MODULE, RECIPE 정보
    modelRowData: {
      type: Object,
      default () {
        return null
      }
    },
    modelType: {
      type: String,
      default: ''
    }
  },
  methods: {
    /**
     * Column initialize
     */
    initColumns () {
      this.columns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.FAB'), field: 'fab', width: 70, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'eqpId', width: 70, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), field: 'moduleId', width: 70, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.LOT_ID'), field: 'lotId', width: 100, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.SUBST_ID'), field: 'substId', width: 150 },
        { headerName: this.$t('fdc.COMMON.COLUMN.START_DATE'), field: 'startDt', type: 'dateTimeColumn', width: 120 },
        { headerName: this.$t('fdc.COMMON.COLUMN.END_DATE'), field: 'endDt', type: 'dateTimeColumn', width: 120 },
        { headerName: this.$t('fdc.COMMON.COLUMN.SLOT'), field: 'slot', type: 'numericColumn', width: 70 },
        { headerName: this.$t('fdc.COMMON.COLUMN.CARRIER_ID'), field: 'carrId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.RECIPE'), field: 'recipeId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.PROD_ID'), field: 'prodId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.PROCESS'), field: 'procId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.RETICLE_ID'), field: 'reticleId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.PPID'), field: 'ppId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.DEVICE'), field: 'device', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.FAULT'), field: 'fault', width: 70 },
        { headerName: this.$t('fdc.COMMON.COLUMN.ALARM'), field: 'alarm', width: 70 },
        { headerName: this.$t('fdc.COMMON.COLUMN.INTER_LOCK'), field: 'interlock', width: 70 }
      ]
    },
    /**
     * Select LOT 목록 조회
     */
    async listFn () {
      if (this.selectPeriodValue !== 'lastLot' && (this.from === null || this.to === null)) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Period']))
        return
      }

      let payload

      /**
       * Lot list param 정의
       * @param {String} fab
       * @param {String} eqpId
       * @param {String} module
       * @param {String} recipeId (ALL일 경우에는 필요 x)
       * @param {String} fromDate
       * @param {String} toDate
       * @param {String} lastLotCnt 최근 lot 건수
       * @param {String} fault 갯수
       * @param {String} alarm 갯수
       * @param {String} Interlock 갯수
       */
      payload = {
        fab: this.modelRowData.fab,
        eqpId: this.modelRowData.eqpId,
        moduleId: this.modelRowData.moduleId,
        recipeId: this.modelRowData.recipeId !== 'ALL' ? this.modelRowData.recipeId : null,
        fromDate: this.selectPeriodValue !== 'lastLot' ? Dayjs(this.from).format('YYYYMMDDHHmmssSSS') : null,
        toDate: this.selectPeriodValue !== 'lastLot' ? Dayjs(this.to).format('YYYYMMDDHHmmssSSS') : null,
        lastLotCnt: !this.lastLotCntDisabled ? this.lastLotCnt : null,
        faultCnt: this.filterFault ? this.filterFaultCnt : null,
        alarmCnt: this.filterAlarm ? this.filterAlarmCnt : null,
        interlockCnt: this.filterInterlock ? this.filterInterlockCnt : null,
        paramName: this.modelRowData.paramName,
        modelType: this.modelType !== 'EQPInfo' ? this.modelType : ''
      }

      let data = await API.Common.getEqpLots(payload)
      // if (data.length === 0) {
      //   this.$dialog.alert('Lot 정보가 없습니다.')
      // }
      this.rowData = data
      this.originRowData = data

      setTimeout(() => {
        this.$refs.lotsGrd.setAllRowsSelected()
      })
    },
    /**
     * Select Lot 목록 검색
     */
    searchProcess () {
      this.listFn()
    },
    /**
     * data 초기화
     */
    resetModalData () {
      this.$emit('lots-modal-visible', false)
      this.selectPeriodValue = 'lastLot'
      this.lastLotCnt = '10'
      this.lastLotCntDisabled = false
      this.from = null
      this.to = null
      this.periodDisabled = true
      this.filterFault = false
      this.filterFaultDisabled = true
      this.filterFaultCnt = null
      this.filterAlarm = false
      this.filterAlarmDisabled = true
      this.filterAlarmCnt = null
      this.filterInterlock = false
      this.filterInterlockDisabled = true
      this.filterInterlockCnt = null
      this.lotsGrd = null
      this.rowData = []
      this.originRowData = []
      this.selectedRowCnt = 0
    },
    /**
     * Apply Lot
     */
    applyLots () {
      let checkedRows = this.$refs.lotsGrd.getCheckedRows()
      if (checkedRows.length > 0) {
        let applyRows = []
        for (let i in checkedRows) {
          var obj = {
            fab: checkedRows[i].fab,
            eqpId: checkedRows[i].eqpId,
            moduleId: checkedRows[i].moduleId,
            endDt: checkedRows[i].endDtStr,
            // endDt: Dayjs(checkedRows[i].endDt).format('YYYYMMDDHHmmssSSS'),
            lotId: checkedRows[i].lotId
          }

          applyRows.push(obj)
        }
        this.$emit('apply-lots', applyRows)
        this.resetModalData()
      } else {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['LOT']))
      }
    },
    /**
     * Auto Spec
     */
    autoSpec () {
      let checkedRows = this.$refs.lotsGrd.getCheckedRows()
      if (checkedRows.length > 0) {
        let applyRows = []
        for (let i in checkedRows) {
          var obj = {
            fab: checkedRows[i].fab,
            eqpId: checkedRows[i].eqpId,
            moduleId: checkedRows[i].moduleId,
            endDt: checkedRows[i].endDtStr,
            // endDt: Dayjs(checkedRows[i].endDt).format('YYYYMMDDHHmmssSSS'),
            lotId: checkedRows[i].lotId
          }

          applyRows.push(obj)
        }
        this.$emit('apply-lots', applyRows)
        this.$emit('auto-spec')
        this.resetModalData()
      } else {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['LOT']))
      }
    },
    /**
     * Select Lots Grid에 check된 row count 확인
     * @returns {Boolean} check된 row가 있는지 여부
     */
    hasCheckedRows () {
      if (!this.$refs.lotsGrd) {
        this.selectedRowCnt = 0
        return 0
      }
      this.selectedRowCnt = this.$refs.lotsGrd.checkedRowCount
      return this.$refs.lotsGrd.checkedRowCount > 0
    }
  },
  data () {
    return {
      lotsGrd: null, // Select Lot grid
      modalVisible: false, // Modal 표시 여부
      selectPeriodValue: 'lastLot', // Period Option value
      lastLotCnt: '10', // Last Top Lot count value
      lastLotCntDisabled: false, // Last Top Lot count value disabled 여부
      from: null, // Direct Selection From Date value
      to: null, // Direct Selection To Date value
      periodDisabled: true, // Direct Selection 기간 disabled 여부
      filterFault: false, // Select LOT Filter > Fault check 여부
      filterFaultDisabled: true, // Select LOT Filter > Fault Count disabled 여부
      filterFaultCnt: null, // Select LOT Filter > Fault Count value
      filterAlarm: false, // Select LOT Filter > Alarm check 여부
      filterAlarmDisabled: true, // Select LOT Filter > Alarm Count disabled 여부
      filterAlarmCnt: null, // Select LOT Filter > Alarm Count value
      filterInterlock: false, // Select LOT Filter > Interlock check 여부
      filterInterlockDisabled: true, // Select LOT Filter > Interlock Count disabled 여부
      filterInterlockCnt: null, // Select LOT Filter > Interlock Count value
      rowData: [], // Select Lot grid row data
      originRowData: [], // Select Lot grid row data
      selectedRowCnt: 0, // 선택된 Lot의 수
      // columns: [
      //   { label: this.$t('fdc.COMMON.COLUMN.FAB'), binding: 'fab', width: 70, readOnly: true, visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.EQP_ID'), binding: 'eqpId', width: 70, readOnly: true, visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), binding: 'moduleId', width: 70, readOnly: true, visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.LOT_ID'), binding: 'lotId', width: 100, readOnly: true },
      //   // 적용 여부 확인
      //   // { label: 'Lot Type', binding: 'lotType', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.SUBST_ID'), binding: 'substId', width: 150, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.START_DATE'), binding: 'startDt', dataType: 'Date', format: 'yyyy-MM-dd HH:mm:ss', centered: true, width: 120, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.END_DATE'), binding: 'endDt', dataType: 'Date', format: 'yyyy-MM-dd HH:mm:ss', centered: true, width: 120, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.SLOT'), binding: 'slot', numeric: true, width: 70, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.CARRIER_ID'), binding: 'carrId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.RECIPE'), binding: 'recipeId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.PROD_ID'), binding: 'prodId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.PROCESS'), binding: 'procId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.RETICLE_ID'), binding: 'reticleId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.PPID'), binding: 'ppId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.DEVICE'), binding: 'device', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.FAULT'), binding: 'fault', width: 70, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.ALARM'), binding: 'alarm', width: 70, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.INTER_LOCK'), binding: 'interlock', width: 70, readOnly: true }
      // ] // Select Lot grid column 배열
      columns: [], // grid column 배열
      defaultColDef: {
        minWidth: 100,
        filter: true,
        sortable: true,
        resizable: true
      } // BRIQUE Grid column default setting
    }
  }
}
